import { render, staticRenderFns } from "./ResCard.vue?vue&type=template&id=012735e2&scoped=true&lang=pug"
import script from "./ResCard.vue?vue&type=script&lang=js"
export * from "./ResCard.vue?vue&type=script&lang=js"
import style0 from "./ResCard.vue?vue&type=style&index=0&id=012735e2&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012735e2",
  null
  
)

export default component.exports